import UnavailableResultsDialog, {
  typeOfUnavailableResultsDialog,
} from './UnavailableResultsDialog';

export default {
  [typeOfUnavailableResultsDialog]: UnavailableResultsDialog,
};
